import api from "../store/services/api";

export const getProducts = (params) => api.get("/products/", { params });

export const getProductsCategories = (params) =>
  api.get("/products/categories/", { params });

export const getIfoodImportedProducts = (params) =>
  api.get("/iFood/import/catalog/items/", { params });

export const getProductsReportData = (params) =>
  api.get("/new/top-product/", { params });

export const createProduct = (product) =>
  api.post("/products/", product, {
    headers: { "Content-Type": "application/json" },
  });

export const editProduct = (product, productId) =>
  api.put(`/products/?pid=${productId}`, product, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteProduct = (productId) =>
  api.delete(`/products/?pid=${productId}`);

export const productsEventsTimePattern = async (params) =>
  await api.get(`/report/products/time-pattern-analysis/`, {
    params,
  });

export const foodTypeTimePattern = async (params) =>
  await api.get(`/report/food-type/time-pattern-analysis/`, {
    params,
  });

const ProductsService = {
  getProducts,
  getProductsCategories,
  getIfoodImportedProducts,
  getProductsReportData,
  createProduct,
  editProduct,
  deleteProduct,
  productsEventsTimePattern,
  foodTypeTimePattern,
};

export default ProductsService;
